import { render } from "./SubUserList.vue?vue&type=template&id=19423de7&scoped=true"
import script from "./SubUserList.vue?vue&type=script&lang=ts"
export * from "./SubUserList.vue?vue&type=script&lang=ts"

import "./SubUserList.vue?vue&type=style&index=0&id=19423de7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19423de7"

export default script